var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-date-picker',{staticClass:"mt-4",attrs:{"allowed-dates":_vm.allowedDates,"min":"2016-06-15","max":"2018-03-20"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }